import type { AppLinkProps } from '@/hooks/usePathHelper'
import { AdminHeaderIconButton } from '@/components/patterns/admin-page'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Can } from '@/lib/casl'
import { Link } from '@tanstack/react-router'
import { EllipsisVertical, History } from 'lucide-react'

export function RecordHistoryMenuItem({
  link,
  label = 'View history',
}: {
  link?: AppLinkProps | null
  label?: string
}) {
  return (
    <Can do="view" on="audit-logs">
      <DropdownMenuItem asChild>
        <Link {...link}>
          <History className="size-4" />
          {label}
        </Link>
      </DropdownMenuItem>
    </Can>
  )
}

export function RecordHistoryActionMenu({
  link,
  triggerLabel = 'More actions',
}: {
  link?: AppLinkProps | null
  triggerLabel?: string
}) {
  return (
    <Can do="view" on="audit-logs">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <AdminHeaderIconButton icon={EllipsisVertical} label={triggerLabel} />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" size="sm">
          <RecordHistoryMenuItem link={link} />
        </DropdownMenuContent>
      </DropdownMenu>
    </Can>
  )
}
